<template style="">
  <div class="Audio_release"  v-loading="loading" element-loading-text="上传中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-form label-width="80px" style="padding-top: 20px;">
      <el-form-item label="音频标题" :rules="[{ required: true, message: '请输入音频标题', trigger: 'blur' }]">
        <el-input style="width: 300px;" v-model="MaterialName" placeholder="请输入音频标题（5-30个汉字）"></el-input>
      </el-form-item>
      <el-form-item label="上传音频" :rules="[{ required: true, message: '请选择上传音频', trigger: 'change' }]">
        <el-upload style="background-color: rgba(0, 136, 255, 1);height: 42px;padding: 0px 20px;color: aliceblue;" :on-change="videohandleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="videohandleAvatarSuccess" 
        v-bind:on-progress="uploadVideoProcess" :before-upload="videobeforeAvatarUpload"  accept=".mp3,.mov">
           上传音频
        </el-upload>
        <p style="margin-left: 120px;color: #606266;">格式支持mp3、mov，文件大小不超过200M，音频时长不超过2小时。上传后音频将进行转码和审核</p>
      </el-form-item>
      <el-form-item v-if="videopd" label="音频预览">
        <audio id="audio" :src="videourl" controls></audio>
      </el-form-item>
      <el-form-item label="上传封面" style="height: 180px;" :rules="[{ required: true, message: '请选择上传文件', trigger: 'change' }]">
        <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"  accept=".jpg, .jpeg, .png">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon">
            <span style="font-size: 16px;">点击选择文件</span>
          </i>
        </el-upload>
        <p style="margin-left: 240px;color: #606266;">请发布与网站主题相关的图片，图片大小需控制在500K以内 文件格式请用.jpg .png .jpeg  图片尺寸建议：2.35:1</p>
      </el-form-item>
      <el-form-item label="栏目" :rules="[{ required: true, message:'请选择栏目', trigger: 'change' }]">
        <!-- <el-cascader ref="wcascader" v-model="ItemKey" @change="Selected_to_shut_dow" @expand-change="bumen" :options="data" :props="{ checkStrictly: true }" clearable placeholder="请选择栏目"></el-cascader> -->
        <el-select v-model="ItemKey" placeholder="请选择栏目">
          <el-option v-for="(item,index) in columnList" :key="index" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标签">
        <el-checkbox-group v-model="Label">
          <el-checkbox v-for="(item,index) in tagList" :key="index" :label="item.key">{{ item.value }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="定时发送">
        <el-radio-group v-model="timisngs">
          <el-radio label="1">否</el-radio>
          <el-radio label="2">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="timisngs == '2'" label="定时时间">
        <el-date-picker v-model="ScheduledRelease" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" :picker-options="pickerOptions" @change="handleDateTimeChange">
          </el-date-picker>
      </el-form-item>
      <el-form-item label="用途">
        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="Purpose"></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input :rows="2" placeholder="请输入内容" v-model="LineNumber"></el-input>
      </el-form-item>
      <!-- <el-form-item label="是否启用">
        <el-switch v-model="isActive" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item> -->
      <el-form-item label="版权声明">
        <el-input type="textarea" :rows="2" placeholder="请输入内容" maxlength="200" v-model="CopyrightStatement"></el-input>
      </el-form-item>
      <el-form-item label="审核意见" v-if="state==1">
        <el-radio-group v-model="AuditStatus">
          <el-radio label="1">通过</el-radio>
          <el-radio label="2">驳回</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="AuditStatus==2 && state==1" label="驳回原因">
        <el-input type="textarea" v-model="ReasonRejection" :autosize="{ minRows: 2}"></el-input>
      </el-form-item>

      <el-form-item style="padding-bottom: 30px;" v-if="state==1">
        <el-button type="primary" :loading="iscontinuous" @click="onSubmit(1)">保存</el-button>
      </el-form-item>

      <el-form-item style="padding-bottom: 30px;" v-else>
        <el-button type="primary" :loading="iscontinuous" @click="onSubmit(1)">{{materialKey?'立即修改':'立即创建'}}</el-button>
        <!-- <el-button type="primary" v-if="!materialKey" :loading="iscontinuous" @click="onSubmit(2)">保存草稿</el-button> -->
      </el-form-item>
    </el-form>
    <el-dialog title="封面裁剪" :visible.sync="Croppdialog" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="closeCroppdialog" width="640px">
      <PictureCropper ref="picture" :initialImg="imageUrl" :cropperHeight="cropperHeight" :cropperWidth="cropperWidth" :autoCropWidth="autoCropWidth" :autoCropHeight="autoCropHeight" @picturePreview="picturePreview"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="Croppdialog=false;">取 消</el-button>
        <el-button type="primary" @click="closeCroppdialog(2)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PictureCropper from '@/components/pictureCropper.vue'
export default {
  components: {PictureCropper},
  data() {
    return { 
      timisngs:'1',
      ScheduledRelease:'',
      iscontinuous:false,
      RoleID:sessionStorage.getItem('RoleID'),
      Purpose: '',
      LineNumber: '',
      delivery: false,
      CopyrightStatement: '',
      data: [],
      loading:false,
      videopd:false,
      videourl:'',
      videoFile:"",//视频文件
      imageFile:"",//图片文件
      MaterialName:"",//视频标题
      Label:[],//标签
      ItemKey:"",//栏目
      img:"",
      imageUrl:'',
      tagList:[],//标签列表
      columnList:[],//栏目列表
      isActive:1,
      state:0,
      AuditStatus:'',
      ReasonRejection:'',
      materialKey:'',

      // 裁剪
      Croppdialog:false,
      previews:{},
      cropperHeight:'600px',//裁剪图片容器高度
      cropperWidth:'600px',//裁剪图片容器宽度
      autoCropWidth:200,
      autoCropHeight:200, 
    }
  },
  // ==== 新增计算属性 ====
  computed: {
    pickerOptions() {
      return {
        disabledDate: (time) => {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
        selectableRange: this.getSelectableRange(),
        // onPick: ({ date }) => {
        //   if (date) {
        //     this.$nextTick(() => {
        //       this.handleDateSelection(date);
        //     });
        //   }
        // }
      };
    }
  },
  mounted() {
    this.getTagList();
    this.getcolumnList();
    this.getColumnManagementByNode();
    this.materialKey = this.$route.query.materialKey;
    if(this.materialKey){
      this.state=this.$route.query.type;
      this.getContentDetails();
    }

    
  },
  methods: {
    // ==== 新增：日期选择处理 ====
    handleDateSelection(date) {
      const now = new Date();
      const selected = new Date(date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selected.setHours(0, 0, 0, 0);
      
      let newDateTime;
      
      if (selected.getTime() === today.getTime()) {
        // 选择今天，直接使用当前时间
        newDateTime = new Date();
      } else {
        // 选择未来日期，设置为上午9点
        newDateTime = new Date(date);
        newDateTime.setHours(9, 0, 0, 0);
      }
      
      this.ScheduledRelease = newDateTime;
    },

    // ==== 新增：获取可选择的时间范围 ====
    getSelectableRange() {
      const now = new Date();
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (!this.ScheduledRelease || this.timisngs !== '2') {
        return ['00:00:00 - 23:59:59'];
      }
      
      try {
        const selectedDate = new Date(this.ScheduledRelease);
        const selectedDay = new Date(selectedDate);
        selectedDay.setHours(0, 0, 0, 0);
        
        if (selectedDay.getTime() === today.getTime()) {
          const currentHour = now.getHours();
          const currentMinute = now.getMinutes();
          
          let startHour = currentHour;
          let startMinute = currentMinute;
          
          const startTime = `${startHour.toString().padStart(2, '0')}:${startMinute.toString().padStart(2, '0')}:00`;
          return [`${startTime} - 23:59:59`];
        }
      } catch (error) {
        console.warn('日期解析错误:', error);
      }
      
      return ['00:00:00 - 23:59:59'];
    },
    // ==== 新增：日期时间变化处理（重要！）====
    handleDateTimeChange(value) {
      // 当用户手动选择时间时，确保时间有效性
      if (value && this.timisngs === '2') {
        const selectedDate = new Date(value);
        const now = new Date();
        
        // 检查选择的日期是否是今天
        const selectedDay = new Date(selectedDate);
        selectedDay.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        // 只有当选择的是今天，并且时间早于当前时间时才进行调整
        if (selectedDay.getTime() === today.getTime() && selectedDate.getTime() < now.getTime()) {
          const adjustedDate = new Date();
          this.ScheduledRelease = adjustedDate;
        }
      }
    },
    getTagList(){
      this.$Http_Post('management/tagList',).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tagList = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },

    getcolumnList(){
      this.$Http_Post('management/columnList',).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.columnList = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },

    getColumnManagementByNode(){
      this.$Http_Post('management/getColumnManagementByNode', { PItemKey: '0', pageIndex: "1", pageSize: "111110", Type: 1,RoleID:this.RoleID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    // 获取详情
    getContentDetails(){
      this.$Http_Post('management/getContentDetails', { MaterialKey: this.materialKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.videourl = res.Data.materialPath;
          this.musicFile=res.Data.materialPath;
          this.videoFile=res.Data.materialPath;
          this.imageUrl = res.Data.materialCover;
          this.imageFile= res.Data.materialCover;
          this.MaterialName = res.Data.materialName;
          this.Label = res.Data.labeles;
          this.ItemKey = res.Data.itemKey.toString();
          this.Purpose=res.Data.purpose;
          this.LineNumber=res.Data.lineNumber;
          this.isActive=res.Data.isActive;
          this.CopyrightStatement=res.Data.copyrightStatement;
          if(res.Data.scheduledRelease){
            this.timisngs = '2';
            this.ScheduledRelease = res.Data.scheduledRelease;
          }
          this.$nextTick(()=>{
            this.defaultMsg = res.Data.richTextContent;
          })
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },

    picturePreview(data){
      this.previews = data
    },
    onSubmit(type) {//创建
      if(!this.MaterialName){
        alert('请输入音频标题');
        return false;
      }
      if(!this.ItemKey){
        alert('请选择栏目');
        return false;
      }
      // 单独检查音频
      if (!this.musicFile && !this.videoFile) {
          this.$message.error('请选择上传音频');
          return false;
      }
      // 单独检查封面
      if (!this.imageFile && !this.imageFile) {
          this.$message.error('请选择上传封面');
          return false;
      }
      this.iscontinuous = true;
      this.loading = true;
      var from = new FormData();
      if(this.materialKey){//修改
        from.append('MaterialKey', this.materialKey);
        from.append('RoleID',sessionStorage.getItem('RoleID'));
      }
      if(this.state==1){
        from.append('AuditStatus', this.AuditStatus);
        if(this.AuditStatus==2){
          from.append('ReasonRejection', this.ReasonRejection);
        }
      }
      from.append('musicFile', this.videoFile.raw==""?"":this.videoFile.raw);
      from.append('imageFile', this.imageFile==""?"":this.imageFile);
      from.append('MaterialName', this.MaterialName);
      from.append('Label', this.Label);
      from.append('ItemKey',  this.ItemKey);
      from.append('Type', type);
      from.append('Purpose', this.Purpose);
      from.append('LineNumber', this.LineNumber);
      from.append('IsActive', this.IsActive ? 1 : 0);
      from.append('CopyrightStatement', this.CopyrightStatement);
      from.append('ScheduledRelease', this.ScheduledRelease);
      this.$Http_Post('management/musicPublishing', from, { 'Content-Type': 'multipart/form-data'}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.iscontinuous = false
          this.videopd = true;
          this.loading = false
          this.videourl = res.Data;
          this.Global.request_successful(res.Message);
           
          if (this.state==1){
              this.$router.push({
              path: '/propagate/Content_review', 
            })
          }else {
              this.$router.push({
              path: '/propagate/index', 
            })
          }

        } else {
          this.iscontinuous = false;
          this.loading = false;
          this.Global.request_failure(res.Message);from.append('ScheduledRelease', this.ScheduledRelease);
        }
      })
    },
    handleChange(file, fileList) {
      if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.imageFile = file;
        this.Croppdialog = true;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传图片' })
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    videohandleChange(file, fileList) {
      if (file.raw.type == 'audio/mpeg' || file.raw.type == 'audio/mp3' || file.raw.type == 'audio/wma' || file.raw.type == 'audio/wav' || file.raw.type == 'audio/amr' || file.raw.type == 'audio/m4a') {
        this.videoFile = file;
        this.$message.success("文件上传成功");
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传音频' })
      }
    },
    videohandleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
    },
    videobeforeAvatarUpload(file) {
      // const isLt2M = file.size / 1024 / 1024 < 8
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!')
      // }
      // return isLt2M
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
      // this.videoFlag = true;
      // this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    Selected_to_shut_dow(dt) {
      this.ItemKey = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    async download(){
      let aLink = document.createElement('a');
      aLink.download = '下载裁剪图片';
      let data = await this.$refs.picture.getBase64();
      aLink.href = data;
      aLink.click();
    },
    // 确认裁剪并关闭弹窗
    async closeCroppdialog(e){
      this.Croppdialog = false;
      if(e == 2){//确认裁剪并关闭
        this.imageUrl  = await this.$refs.picture.getBase64();
        this.imageFile = await this.$refs.picture.getfile(this.imageUrl,Math.floor(new Date().getTime())+'.png');
      }
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].value == ID) {
          obj = NodeList[i];
          break;
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].value != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children);
          if (obj != null) break
        }
      }
      return obj
    },
    bumen(dt) {
      let obj = this.data[0];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].value == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].value != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].value == '-2') {
        obj.children = [{ label: this.$t('original.languages22') }]
        this.$Http_Post('/management/getColumnManagementByNode', { PItemKey: dt[dt.length - 1], pageIndex: "1", pageSize: "111110", Type: 1,RoleID:this.RoleID}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }
    },
  },
}
</script>
<style>
.Audio_release{background-color: #fff;min-height: 100%;width: 100%;}
  /* .avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;} */
.Audio_release .avatar-uploader .el-upload:hover {border-color: #409eff;}
.Audio_release .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
.Audio_release .avatar {width: 215px;height: 148px;display: block;}
.Audio_release .cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 175px;}
.Audio_release .avatar-uploader {position: absolute;top: 0px;left: 0px;}
.Audio_release .cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 330px;width: 350px;}
.Audio_release .scale {margin-top: 30px;max-height: 333px;overflow:overlay;}
.Audio_release .scale,.scale0 {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;max-height: 333px;overflow: overlay;}
.Audio_release .el-textarea{width: 400px;}
.Audio_release .el-input{width: 300px;}
</style>
